var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPriceTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 2c0-.5.5-1 1-1h10.4c.3 0 .6.1.8.3l8.9 9a3.1 3.1 0 0 1 0 4.3l-7.5 7.5a3.1 3.1 0 0 1-4.4 0l-8.9-9a1 1 0 0 1-.3-.7V2.1Zm2.1 1.1V12l8.6 8.6a1 1 0 0 0 1.5 0l7.4-7.4a1 1 0 0 0 0-1.5L12 3.1H3.1Zm3.1 4.2c0-.6.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1Z",
  fill: "currentColor"
})));
export default SvgPriceTag;